const FAILED_ORDERS = "FAILED_ORDERS";
const FAILED_ORDERS_SUCCESS = "FAILED_ORDERS_SUCCESS";
const FAILED_ORDERS_FAILURE = "FAILED_ORDERS_FAILURE";
const CLEAR_FAILED_ORDERS = "CLEAR_FAILED_ORDERS";
const FailedOrdersSymbols = {
  FAILED_ORDERS_SUCCESS,
  FAILED_ORDERS_FAILURE,
  FAILED_ORDERS,
  CLEAR_FAILED_ORDERS,
};
export default FailedOrdersSymbols;
